import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
`;

export const ImageWrapper = styled.div<{ size?: number }>`
  width: ${({ size }) => (size ? size : '32')}px;
  height: ${({ size }) => (size ? size : '32')}px;
  border: 1px solid ${({ theme }) => theme.colors.gray400};
  border-radius: 50%;
  overflow: hidden;
`;

export const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const RedPoint = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 9px;
  height: 9px;
  border-radius: 9px;
  background: ${({ theme }) => theme.colors.red500};
`;
